export const boardWhiteSpaceTour = {
  key: "boardWhiteSpace",
  version: 1,
  getSteps: (t) => [
    {
      target: "body",
      content: t("Tour_BoardWhiteSpace_Canvas"),
      placement: "center",
      disableBeacon: true,
    },
    {
      target: "body",
      content: t("Tour_BoardWhiteSpace_Draw"),
      placement: "center",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-whitespace-save"]',
      content: t("Tour_BoardWhiteSpace_Save"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-whitespace-share"]',
      content: t("Tour_BoardWhiteSpace_Share"),
      placement: "bottom",
    },
  ],
};
